const menus = [
    {
        id: 2,
        name: 'Network',
        links: '#network',
        isHash: true,
    },
    {
        id: 9,
        name: '🎁 TedLotto',
        links: 'https://lotto.tedcrypto.io',
        isHash: false,
    },
    {
        id: 4,
        name: 'Community',
        links: '#community',
        isHash: true,
    },
    {
        id: 5,
        name: 'Resources',
        links: '#resources',
        isHash: true,
    },
    {
        id: 6,
        name: 'FAQ',
        links: '#FAQ',
        isHash: true,
    },
    {
        id: 7,
        name: 'Team',
        links: '#team',
        isHash: true,
    },
    {
        id: 8,
        name: 'Contact',
        links: '#Contact',
        isHash: true,
    },
]

export default menus;
